import { Button } from "@/components/ui/baseUi/button"
import { Path } from "@/modules/navigation/routes"
import { AuthContent, AuthPage } from "@modules/auth/components/authComponents"
import { word } from "@modules/core/utils/i18n"
import { Link } from "react-router"
import { Text } from "@/components/ui/baseUi/text"

export function WelcomePage() {
  return (
    <AuthPage>
      <AuthContent className="justify-center gap-4 text-center">
        <Text fontStyle="TM">{word("auth.welcomeBack")}</Text>
        <Text fontStyle="BM">{word("auth.welcome.description")}</Text>

        <Button
          className="w-full"
          variant="primary"
          size="lg"
          nativeButton={false}
          render={<Link to={Path.SignUp}>{word("auth.login.form.create_account")}</Link>}
        />

        <Button
          variant="secondary"
          className="w-full"
          size="lg"
          nativeButton={false}
          render={<Link to={Path.Login}>{word("auth.login.form.button.login")}</Link>}
        />
      </AuthContent>
    </AuthPage>
  )
}
